import { Typography } from '../../../components/Typography'
import { ReactComponent as AdminSplitFees } from 'assets/svg/Hospital.svg'

export const Empty = () => {
  return (
    <div className="column full-width gap-24 align-center justify-center mt-120">
      <AdminSplitFees />
      <Typography.Headline6 className="empty-chat__text">
        No Admin split fees added yet.
      </Typography.Headline6>
    </div>
  )
}
